import { Game } from 'boardgame.io';
import type { BarbadosGameState } from '../types';
import { setupBarbadosGame } from './setupBarbados';
import { issueSharesPhase } from './phases/issueSharesPhase';
import { selectActionsBarbadosPhase } from './phases/selectActionsBarbadosPhase';
import { buildTrackPhase } from './phases/buildTrackPhase';
import { moveGoodsPhase } from './phases/moveGoodsPhase';
import { collectIncomePhase } from './phases/collectIncomePhase';
import { payExpensesPhase } from './phases/payExpensesPhase';
import { incomeReductionPhase } from './phases/incomeReductionPhase';
import { refillGoodsPhase } from './phases/refillGoodsPhase';
import { advanceTurnPhase } from './phases/advanceTurnPhase';
import { wrapPhaseMoves } from './utils/moveLogger';

/**
 * Age of Steam - Barbados Solo Play ゲーム定義（Boardgame.io）
 *
 * Barbados固有ルールに従ったソロプレイ専用ゲーム実装。
 * 実装済み: Phase 1, 3-10
 * 未実装: Phase 2（プレイ順決定、Barbadosではスキップ）
 *
 * @see docs/specifications/logic/barbados/*.md
 * @see data/map/barbados_rules.md
 */
export const BarbadosGame: Game<BarbadosGameState> = {
  name: 'age-of-steam-barbados',

  // デフォルトのターン動作
  turn: {},

  setup: ({ ctx }: { ctx: any }) => {
    // Boardgame.io v0.50では、setup関数の第1引数は { ctx, ... } の形式
    return setupBarbadosGame(ctx);
  },

  // プレイヤー人数の範囲（Barbados Solo Play: 固定1人）
  minPlayers: 1,
  maxPlayers: 1,

  phases: wrapPhaseMoves({
    // Phase 1: 株式発行（共通Phase、maxSharesPerTurn: 1 で1株制限）
    issueShares: issueSharesPhase as any,

    // Phase 2: プレイ順決定はBarbadosではスキップ

    // Phase 3: アクション選択（Barbados固有）
    selectActions: selectActionsBarbadosPhase,

    // Phase 4: 線路建設（共通Phase）
    buildTrack: buildTrackPhase as any,

    // Phase 5: 商品輸送（共通Phase）
    moveGoods: moveGoodsPhase as any,

    // Phase 6: 収入獲得（自動処理Phase）
    collectIncome: collectIncomePhase as any,

    // Phase 7: 経費支払い（自動処理Phase）
    payExpenses: payExpensesPhase as any,

    // Phase 8: 収入減少（自動処理Phase）
    incomeReduction: incomeReductionPhase as any,

    // Phase 9: 商品補充（Production選択時以外は自動処理）
    refillGoods: refillGoodsPhase as any,

    // Phase 10: ターン進行（自動処理Phase）
    advanceTurn: advanceTurnPhase as any
  }),

  // ゲーム終了条件
  endIf: ({ G }: { G: BarbadosGameState }) => {
    if (G.isGameOver) {
      // Barbados Solo Play: 勝敗はisVictoriousで判定
      const soloPlayer = G.players['0'];
      return {
        winner: soloPlayer.isVictorious ? '0' : undefined
      };
    }
  }
};
